/**
 * Parst Datumsstrings aus der API (Format: "Y-m-d H:i:s")
 * Safari kann das Leerzeichen zwischen Datum und Uhrzeit nicht parsen,
 * daher wird es durch "T" ersetzt (ISO 8601).
 */
export function parseDate(str) {
  if (!str) return new Date(NaN)
  return new Date(str.replace(' ', 'T'))
}
